import {Box, Button, Grommet, grommet, Header, Heading} from "grommet";
import React, {useState} from "react";
import {confirmAlert} from "react-confirm-alert";
import {deepMerge} from "grommet/utils";
import api from "../utils/api";

const theme = deepMerge(grommet, {
    global: {
        colors: {
            brand: '#C01219',
        },
        font: {
            family: "Playfair Display",
            size: "18px",
            height: "20px",
        },
    },
});
const retrieveUserCardInfo = (email, points) => {

    api.get(process.env.REACT_APP_BASE_API_URL + 'api/users?' + email, { params: { email: email } } ).then((response) => {
        if (response.data["hydra:member"][0].fidelityCards.length > 0) {
            let card = response.data["hydra:member"][0].fidelityCards[0]["@id"];

            api.post(process.env.REACT_APP_BASE_API_URL + 'api/transactions',
                {
                    "amount": parseInt(points),
                    "fidelityCard": card
                }
            ).then((response) => {

            }).catch(error => {
                console.error(error);
            });
        }
    }).catch(error => {
        console.error(error);
    });
};

const handleSubmit = (scannedEmail, points) => {
    retrieveUserCardInfo(scannedEmail, points);

};
const ConfirmationDialog = (scannedEmail, points) => (

    confirmAlert({
        customUI: ({onClose}) => {
            return (
                <>
                    <Grommet theme={theme} full>
                        <Box
                            pad="medium"
                            justify={"center"}
                            align={"center"}
                            alignSelf={"center"}
                        >
                            <Heading>Confermi l'inserimento di {points} punti for {scannedEmail}?</Heading>
                            <Box direction="row" justify="end" margin={{top: "medium"}}
                                 gap={"medium"}
                                 pad={"medium"}
                            >
                                <Button
                                    onClick={() => {
                                        handleSubmit(scannedEmail, points)
                                        onClose();
                                    }}
                                    gap={"medium"}
                                    label={"Sì"}
                                    primary color={"brand"}>

                                </Button>
                                <Button
                                    onClick={onClose}
                                    gap={"medium"}
                                    label={"No"}>
                                </Button>
                            </Box>
                        </Box>
                    </Grommet>
                </>
            );
        }
    })
    )
;


export default ConfirmationDialog